<template>
  <el-form rel="ruelForm" :model="form" label-width="100px">

    <el-row>
      <el-col :span="12">
        <el-form-item prop="bmf" label="占用版面数">
          <el-input-number :min="1.0" :max="50" :precision="1" :step="0.5" v-model="form.publishPage"
            controls-position="right"></el-input-number>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item prop="bmf" label="收费标准">
          <span class="sfbz">{{ sfbz.toFixed(2) }}</span> 元/版面
        </el-form-item>
      </el-col>

      <el-col :span="12">
        <el-form-item prop="bmf" label="应收版面费">
          <el-input-number :min="0.01" :precision="2" v-model="form.bmf" controls-position="right"></el-input-number>
        </el-form-item>
      </el-col>

      <el-col :span="12">
        <el-form-item prop="bmf" label="拟发表时间">
          <el-date-picker style="width:130px;" v-model="form.publishTime" type="month" placeholder="选择月" format="yyyy-MM"
            value-format="yyyy-MM"> </el-date-picker>
        </el-form-item>
      </el-col>
    </el-row>

    <el-form-item style="margin-bottom:0;">
      <el-button type="primary" @click="submit" :loading="btnLoading">提交</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import editorApi from "@/api/editor"
export default {
  props: {
    articleId: {
      type: Number,
      require: true,
    },
  },

  data() {
    return {
      form: {
        publishPage: "",
        bmf: 0,
        publishTime: ""
      },

      sfbz: 0,
      btnLoading:false,
    }
  },

  watch: {
    'form.publishPage'(newValue) {
      this.form.bmf = newValue * this.sfbz;
    }
  },

  created() {
    if(process.env.VUE_APP_PLATFORM == 'test'){
      this.sfbz = 0.01;
    }else{
      this.sfbz = process.env.VUE_APP_PLATFORM == 'dx' ? 1500 : 1200;
    }
    
  },

  methods: {
    submit() {
      let articleIds = [this.articleId]
      let amounts = [this.form.bmf];
      let letterNoticePage = [this.form.publishPage]
      let letterNoticeTime = [this.form.publishTime]

      this.btnLoading = true;
      editorApi.doCharge(articleIds, amounts, letterNoticePage, letterNoticeTime).then((res) => {

        this.btnLoading = false;
        if (res.code == 0) {
          this.drawer = false
          this.$notify.success({
            title: "成功",
            message: "登记成功！",
          })
          this.$emit("submitSuccess")
        } else {
          this.$notify.error({
            title: "错误",
            message: res.msg,
          })
        }
      })
    },
  },
}
</script>


<style lang="scss" scoped>
.sfbz {
  font-size: 24px;
  color: #F56C6C;
}
</style>